export default function isMobileDevice() {
  try {
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent);
  } catch (_unused) {
    return false;
  }
}